// enquiry type values
export const ENQUIRY_TYPE_GENERAL_ENQUIRY_VALUE = 'generalEnquiry';
export const ENQUIRY_TYPE_INVESTING_WITH_FORSYTH_BARR_VALUE = 'investingForsythBarr';
export const ENQUIRY_TYPE_BUYING_AND_SELLING_SHARES_VALUE = 'buyingSellingShares';

// how to invest values
export const HOW_TO_INVEST_AS_AN_INDIVIDUAL_VALUE = 'individual';
const HOW_TO_INVEST_JOINT_VALUE = 'joint';
const HOW_TO_INVEST_TRUST_VALUE = 'trust';
const HOW_TO_INVEST_COMPANY_VALUE = 'company';
const HOW_TO_INVEST_DONT_KNOW_VALUE = 'dontKnow';

export const enquiryType = [
    // Changing the values here will break the API.
    // Do not change unless you are changing both environments.
    { value: ENQUIRY_TYPE_INVESTING_WITH_FORSYTH_BARR_VALUE, label: 'Investing with Forsyth Barr' },
    { value: ENQUIRY_TYPE_BUYING_AND_SELLING_SHARES_VALUE, label: 'Buying and selling shares' },
    { value: ENQUIRY_TYPE_GENERAL_ENQUIRY_VALUE, label: 'A general enquiry' },
];

export const nearestLocation = [
    { value: 'Whangarei', label: 'Whangarei' },
    { value: 'Orewa', label: 'Auckland - Orewa' },
    { value: 'North Shore', label: 'Auckland - North Shore' },
    { value: 'Auckland Central', label: 'Auckland - Central' },
    { value: 'Auckland East', label: 'Auckland - East' },
    { value: 'Hamilton', label: 'Hamilton' },
    { value: 'Tauranga', label: 'Tauranga' },
    { value: 'Cambridge', label: 'Cambridge' },
    { value: 'Napier', label: 'Napier' },
    { value: 'Havelock North', label: 'Havelock North' },
    { value: 'New Plymouth', label: 'New Plymouth' },
    { value: 'Palmerston North', label: 'Palmerston North' },
    { value: 'Masterton', label: 'Masterton' },
    { value: 'Kapiti', label: 'Kapiti' },
    { value: 'Lower Hutt', label: 'Lower Hutt' },
    { value: 'Wellington', label: 'Wellington' },
    { value: 'Nelson', label: 'Nelson' },
    { value: 'Marlborough', label: 'Marlborough' },
    { value: 'Christchurch', label: 'Christchurch' },
    { value: 'Ashburton', label: 'Ashburton' },
    { value: 'Timaru', label: 'Timaru' },
    { value: 'Wanaka', label: 'Wanaka' },
    { value: 'Queenstown', label: 'Queenstown' },
    { value: 'Dunedin', label: 'Dunedin' },
    { value: 'Invercargill', label: 'Invercargill' },
    { value: 'Not based in New Zealand', label: 'Not based in New Zealand' },
];

export const howToInvest = [
    // Changing the values here will break the API.
    // Do not change unless you are changing both environments.
    { value: HOW_TO_INVEST_AS_AN_INDIVIDUAL_VALUE, label: 'As an individual' },
    { value: HOW_TO_INVEST_JOINT_VALUE, label: 'Jointly with someone else' },
    { value: HOW_TO_INVEST_TRUST_VALUE, label: 'On behalf of a Trust or Estate' },
    { value: HOW_TO_INVEST_COMPANY_VALUE, label: 'On behalf of a Company, Incorporated Society, etc.' },
    { value: HOW_TO_INVEST_DONT_KNOW_VALUE, label: 'I don\'t know yet' },
];

export const howMuchToInvest = [
    { value: '$0 - $50,000', label: '$0 - $50,000' },
    { value: '$50,000 - $250,000', label: '$50,000 - $250,000' },
    { value: '$250,000 - $1,000,000', label: '$250,000 - $1,000,000' },
    { value: '$1,000,000 or more', label: '$1,000,000 or more' },
    { value: 'I\'d rather not say', label: 'I\'d rather not say' },
];

export const investedBefore = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
